import { SVGProps } from "react";

const CardHero3MobUnderline = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 159 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.00183 10C36.1513 1.93457 123.189 13.368 152.002 7.35523"
        stroke="#FFA686"
        strokeWidth="14"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CardHero3MobUnderline;
